




































import Vue from "vue";
import ApiService from "@/services/ApiService";
import FilteringMain from "@/components/FilteringMainv2.vue";
export default Vue.extend({
  data() {
    return {
      selection: [],
      schools: [],
      // accType: "",
      activeTab: "first",
      filterOptions: {},
      stats: {
        total_users: 0,
        total_staff: 0,
        total_parents: 0,
        total_children: 0,
        total_cars: 0,
        total_active_time: 0,
        total_time: 0.01,
        total_distance: 0,
        total_journeys: 0,
        total_co2: 0,
        groupByDistance: [],
        groupsByTime: [],
        groupsByDistanceGroup: [],
        groupsByDistanceGroupCount: [],
        groupsByDistanceCountFormattedPercents: [],
        carsVsSustainable: [],
        journeysDistributionByDistance: [],
        carsData: {
          total_car_distance: "0",
          total_car_time: "0",
          total_car_journeys: 0,
          DIESEL: 0,
          PETROL: 0,
          ELECTRIC: 0,
          HUBRID: 0,
          total_pupils: "0",
          shared: "0",
        },
        habbitsBySchoolYear: [],
      },
      loading: false,
    };
  },
  components: {
    FilteringMain,
  },
  computed: {
    accType() {
      return this.$store.state.accType;
    },
  },
  methods: {
    updateMainFilter(data) {
      this.loading = true;
      this.filterOptions = data;
      ApiService.generalApi.getMainStats(data).then((response) => {
        this.loading = false;
        this.$nextTick(() => {
          this.stats = response.data.data;
          this.$forceUpdate();
        });
      });
    },
    switchTab(tab) {
      this.$router.push(tab.paneName);
    },
  },
  mounted() {
    this.activeTab = this.$route.path.toLowerCase().split("/")[3];
  },
});
